module.exports = __webpack_public_path__ + "static/media/car-3.2f55178a.png";